import React, { useState } from 'react'
import { useAuth } from '../Core/Auth'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { loginUser } from '../../../../api'

interface LoginCred {
  email: string
  password: string
}

const Login = () => {
  const { saveAuth, setCurrentUser } = useAuth()
  const navigator = useNavigate()
  const [showPassword, setShowPassword] = useState(false)
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [loginCred, setLoginCred] = useState({ email: '', password: '' } as LoginCred)

  const validateEmail = (email: string) => {
    const pattern = /^[^\s@]+@mapmycrop\.com$/
    return pattern.test(email)
  }
  const loginHandler = async (e: React.FormEvent) => {
    e.preventDefault()
    let valid = true
    if (!validateEmail(loginCred.email)) {
      setEmailError('Email does not have valid domain name')
      valid = false
    } else {
      setEmailError('')
    }
    if (loginCred.password.length < 8) {
      setPasswordError('Password must be at least 8 characters long')
      valid = false
    } else {
      setPasswordError('')
    }

    if (valid) {
      try {
        const response = await loginUser(loginCred)
        const responseData = await response.json()
        if (response.status === 200) {
          const user = {
            username: responseData.user.name,
            role: responseData.user.role,
            password: loginCred.password,
            email: loginCred.email,
            first_name: 'string',
            last_name: 'string',
            access_token: responseData.user.access_token,
          }
          const token = responseData.user.access_token
          const data = {
            api_token: token,
            refreshToken: 'string',
          }
          saveAuth(data)
          setCurrentUser(user)
          Swal.fire({
            icon: 'success',
            title: 'Login Successful',

            text: `${user.username} has successfully logged in.`,
          });

          if (user.role === "Admin") {
            navigator("/dashboard");
          } else if (user.role === "Operations") {
            navigator("/s6-activation");
          } else if (user.role === "Sales" || user.role === "Agronomist") {
            navigator("/customer-interaction");
          } else {
            navigator('/error/404')
          }
        } else {
          const errorMessage = responseData.detail
          Swal.fire({
            icon: 'error',
            title: errorMessage,
          })
        }
      } catch (error) {
        console.error('Error:', error)
      }

    }
  }


  return (
    <div className='d-flex flex-column flex-root vh-100'>
      <div className='d-flex flex-column flex-lg-row h-100 w-100'>
        <div
          className='d-flex align-items-center justify-content-center w-100'
          style={{
            flex: '7',
            height: '100vh',
          }}
        >
          <img
            src='/assets/media/logos/background.jpg'
            alt='Login'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
        <div
          className='d-flex flex-column justify-content-center align-items-center p-10 w-100'
          style={{
            flex: '3',
            minHeight: '100vh',
            maxHeight: '50vh',
            overflowY: 'auto',
          }}
        >
          <div
            className='fixed'
            style={{
              top: '10%',
              right: '160px',
              transform: 'translateY(-50%)',
              paddingBottom: '4%',
              zIndex: 1000,
            }}
          >
            <img
              alt='logo'
              src='/assets/media/logos/mapmycrop.png'
              style={{
                width: '200px',
                height: '50px',
              }}
            />
          </div>
          <div
            className='bg-body d-flex flex-column flex-center rounded-4 p-10 w-100'
            style={{
              maxWidth: '450px',
              width: '100%',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          >
            <div className='d-flex flex-center flex-column align-items-stretch w-100'>
              <form className='form w-100' onSubmit={loginHandler}>
                <div className='text-center mb-11'>
                  <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>

                </div>

                {/* Email Input */}
                <div className='fv-row mb-8'>
                  <input
                    type='email'
                    placeholder='Email'
                    name='email'
                    value={loginCred.email}
                    className='form-control bg-transparent'
                    onChange={(e) => setLoginCred({ ...loginCred, email: e.target.value })}
                    required
                  />
                  {emailError && <div className='text-danger mt-2'>{emailError}</div>}
                </div>
                {/* Password Input */}
                <div className='fv-row mb-8 position-relative'>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder='Password'
                    name='password'
                    value={loginCred.password}
                    className='form-control bg-transparent'
                    onChange={(e) => setLoginCred({ ...loginCred, password: e.target.value })}
                    required
                  />
                  {loginCred.password && (
                    <span
                      className='position-absolute top-50 translate-middle-y'
                      style={{ right: '10px', cursor: 'pointer' }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  )}
                  {passwordError && <div className='text-danger mt-2'>{passwordError}</div>}
                </div>
                <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
                  <div></div>
                  <Link to='/auth/forgot-password' className='link-primary'>
                    Forgot Password ?
                  </Link>
                </div>

                {/* Sign In Button */}
                <div className='d-grid mb-10'>
                  <button type='submit' className='btn btn-primary'>
                    <span className='indicator-label'>Sign In</span>
                  </button>
                </div>
                <div className='text-gray-500 text-center fw-semibold fs-6'>
                  Not a Member yet? <Link to='/auth/registration'>Sign up</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
